import React from 'react';
export var GiphySVG = (React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M13.333 17.778H2.223V2.222H6.11L8.333 0H0v20h15.556V7.222l-2.223 2.222v8.334z" }),
    React.createElement("path", { d: "M13.333 4.444V2.222h-2.222V0H8.89v6.667h6.667V4.444h-2.223z" })));
